import { useEffect, useState } from "react";
import { useLocalStorage } from "react-use";
import { useTranslation } from "react-i18next";

import { MdOutlineMonetizationOn } from "react-icons/md";
import { Button, Col, Container, Row } from "react-bootstrap";
import { ListFilters } from "../components/list-filters";
import { MyLinks } from "../favorites/components/my-links-list";

import { ISubscription } from "../../../models/ISubscriptionDetails";
import { useNotification } from "../../../../hooks/useNotifications";
import { FilterButton } from "../styled";
import { useRecoilState } from "recoil";
import { subscriptionState } from "../../../../hooks/atoms/subscriptions";

export const Materials = (): JSX.Element => {
	const { t: translation } = useTranslation();
	// const [subscriptionDetails] = useLocalStorage<ISubscription>("subscription");
	const [subscriptionDetails, setSubscriptionDetails] = useRecoilState(subscriptionState)

	const [totalLinksDisciplines, setTotalLinksDisciplines] = useState(0);
	const [filters, setFilters] = useState({});

	const [statusFilter, setStatusFilter] = useState<boolean>(true);

	const { updateNotification } = useNotification();

	useEffect(() => {
		updateNotification({ quantity: 0 });
	}, []);

	const handleFilters = (event?: any) => {
		setFilters({ ...event, page: 1, is_active: statusFilter });
	};

	const handlePageChange = (event?: any) => {
		setFilters({ ...filters, page: event, is_active: statusFilter  });
	};

	const handleStatusChange = (event?: any) => {
		setStatusFilter(event);
		setFilters({ ...event, page: 1, is_active: event });
	};

	return (
		<Container fluid>
			<Row>
				<Col md={6}>
					<h3 className="title-materials">
						{translation("components.menu.myMaterials")}
						<span className="ml-3 font-14 text-dark-grey">
							{totalLinksDisciplines} disciplinas
						</span>
					</h3>
				</Col>
				{subscriptionDetails &&
					totalLinksDisciplines >=
						subscriptionDetails?.subscription
							?.subscription_limit && (
						<Col
							md={6}
							className="text-end"
						>
							<span className="text-black mr-2 font-14">
								Adquira um novo plano para utilizar mais
								disciplinas
							</span>
							<Button
								variant="warning"
								className="btn-plans"
								onClick={() =>
									window.open(
										`https://dstoreconteudos.com.br/#planos`,
										"_blank"
									)
								}
							>
								<MdOutlineMonetizationOn size="23" /> Ver Planos
							</Button>
						</Col>
					)}
			</Row>
			<hr />
			<Row className="mb-4">
				<ListFilters handleFilter={handleFilters}></ListFilters>
			</Row>

			<Row className="mb-4">
				<div className="d-flex gap-3" style={{ borderBottom: '1px solid #EEEEEE'}}>
					<FilterButton
						className={statusFilter === true ? "active" : ""}
						onClick={() => handleStatusChange(true)}
					>
						Utilizados
					</FilterButton>
					<FilterButton
						className={statusFilter === false ? "active" : ""}
						onClick={() => handleStatusChange(false)}
					>
						Inativos
					</FilterButton>
				</div>
			</Row>

			<MyLinks
				listFilter={filters}
				handlePageChange={handlePageChange}
				setTotalLinks={setTotalLinksDisciplines}
			/>
		</Container>
	);
};
